<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/agentList' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>经纪人</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>添加经纪人</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item">
          <el-input
            id="auto-0"
            style="width: 200px"
            class="mr-10"
            v-model.trim="tableOptions.userMobile"
            :maxlength="11"
            placeholder="请输入经纪人手机号码"
          >
          </el-input>
          <el-input
            id="auto-1"
            style="width: 200px"
            class="mr-10"
            v-model.trim="tableOptions.userName"
            :maxlength="10"
            placeholder="请输入经纪人名称"
          >
          </el-input>
          <el-button type="primary" size="small" @click="search" id="auto-2">搜索</el-button>
          <el-button type="primary" size="small" @click="back" id="auto-3">返回列表</el-button>
        </div>
      </div>
    </div>
    <div class="table-custom-box" id="auto-4">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <template #handle="{ scope }">
          <el-button type="text" class="font-size12" @click="add(scope.row.agentCode)">添加</el-button>
        </template>
      </fe-table>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import tableMixin from '@/utils/tableMixin';
import { isInt, isRangeNumber } from '@fe/validator';

export default {
  mixins: [tableMixin],
  data() {
    return {
      columns: [
        { label: '经纪人名称', prop: 'agentName', 'min-width': 100 },
        { label: '联系电话', prop: 'agentMobile', 'min-width': 100 },
        { label: '操作', prop: 'handle', 'min-width': 100 }
      ],
      tableOptions: { userName: null, userMobile: null },
      axiosConfig: { url: api.findAgentList }
    };
  },
  methods: {
    checkNumberVali(val) {
      if (isInt(val, false) && isRangeNumber(val, 100, 19999999999)) {
        return true;
      }
      return false;
    },
    search() {
      if (!this.tableOptions.userMobile && !this.tableOptions.userName) {
        this.$message.error('请输入经纪人手机号码或经纪人名称进行搜索');
        return;
      }
      if (this.tableOptions.userMobile && !this.checkNumberVali(this.tableOptions.userMobile)) {
        this.$message.error('请至少输入3位数字');
        return;
      }
      this.handleSearch();
    },
    async add(agentCode) {
      await axios.post(api.saveCompanyAgent, { agentCode });
      this.$message.success('添加成功');
      this.$router.go(-1);
    },
    back() {
      this.$router.push({ path: '/agentList' });
    }
  }
};
</script>
